import { useAppConstantsContext } from '@/context/AppConstants';
import { EmptyVehicleSectionDisclaimer } from '@/reports/shared/ReportSection/EmptyVehicleSectionDisclaimer/EmptyVehicleSectionDisclaimer';
import { ReportSection } from '@/reports/shared/ReportSection/ReportSection';
import { HowItWorksCTA } from '@/reports/shared/ReportSection/components';
import { AutomobileThefts } from '@/reports/types/vehicles';
import { Text } from '@/theme/index';
import { VehicleTheftCard } from './VehicleTheftCard';

interface VehicleTheftsProps {
  vehicleTheftsList: AutomobileThefts;
}

function HowItWorksCTAContent() {
  const {
    data: { brandName },
  } = useAppConstantsContext();

  return (
    <Text
      variant="body2"
      fontSize="0.9rem"
      color={(theme) => theme.palette.grey[800]}
    >
      Theft data included in {brandName} reports originates from FBI National
      Crime Information Center (NCIC). The NCIC is a governmental system that
      receives vehicle theft data from approximately 18,000 criminal justice
      agencies and other law enforcement authorities throughout the United
      States. This national data includes the reported thefts of self-insured
      and uninsured vehicles, not all of which are reported to other data
      sources. Most theft records are only alerts that include the date and
      status of the theft, nothing more. Thefts may include data in the US and
      Mexico.
    </Text>
  );
}

export function VehicleThefts({ vehicleTheftsList }: VehicleTheftsProps) {
  const title = 'Theft Records';

  return (
    <ReportSection
      showTopBar
      title={title}
      hasContent={vehicleTheftsList?.length > 0}
      sectionId="vehicle-thefts"
      data-testid="vehicle-thefts-report-section"
      howItWorks={<HowItWorksCTA content={HowItWorksCTAContent()} />}
      customEmptyText={<EmptyVehicleSectionDisclaimer title="theft" />}
    >
      {vehicleTheftsList &&
        vehicleTheftsList.map((theft, index) => (
          <VehicleTheftCard theft={theft} key={index} />
        ))}
    </ReportSection>
  );
}
